<template>
  <div class="intro-personality-intro-content" id="plataforma-de-marca-personalidade-introducao" data-search-anchor>
    <div class="description-personality-intro-content">
      <h1 class="intro-personality-intro-description">{{ introDescription }}</h1>
    </div>

    <div
      class="intro-personality-intro-card-item"
      :style="{ backgroundImage: `url(${introImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonalityPageMixin from '@/mixins/personality-page-mixin'
import {PersonalityPageStore } from '@/store/brand-plataform-page/personality-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonalityIntroSection extends Mixins(
  PersonalityPageMixin
) {
  personalityPageStore: PageStoreContract = getModule(
    PersonalityPageStore,
    this.$store
  )

  get introDescription(): string {
    return this.getElementText(1, 0)
  }

  get introImageSrc(): string {
    return this.getElementMedia(1,1)
  }

  async getPersonalityPage(): Promise<void> {
    await this.personalityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personalityPageStore.isLoading) {
      await this.getPersonalityPage()
    }
  }
}
</script>

<style lang="scss">
.intro-personality-intro-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;
}

.description-personality-intro-content {
  font-size: 70px;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: -.01em;
  text-align: left;
  margin-top: 1rem;
  padding-right: 52px;
}

.intro-personality-intro-description {
  font-size: 56px;
  font-weight: 400;
  line-height: 54px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
}

.intro-personality-intro-card-item {
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center; 
  background-size: cover;
}
</style>
